export default __webpack_public_path__ + "static/media/IMG_1535.9a767d8d.JPG";